import { FlexRow } from '@gorila-shared-ui/components';
import { useRecoilState } from 'recoil';
import { EVIDENCE_ORIGIN_OPTIONS, MEDIA_TYPE_OPTIONS } from '../../../constants/reports';
import {
  evidenceAlarmFilterState,
  evidenceMediaTypeFilterState,
  evidenceOriginFilterState,
} from '../../../storage/reports';
import AlarmTypeSelect from '../../shared/alarmTypeSelect';
import { EnhancedLabeledSelect } from '../../ui/EnhancedLabeledSelect';

function EvidencesReportFilters() {
  const [alarm, setAlarm] = useRecoilState(evidenceAlarmFilterState);
  const [mediaType, setMediaType] = useRecoilState(evidenceMediaTypeFilterState);
  const [origin, setOrigin] = useRecoilState(evidenceOriginFilterState);
  const mediaTypeOptions = [{ id: undefined, label: 'Todos' }, ...MEDIA_TYPE_OPTIONS];
  const originOptions = [{ id: undefined, label: 'Todos' }, ...EVIDENCE_ORIGIN_OPTIONS];

  return (
    <FlexRow>
      <EnhancedLabeledSelect
        inline
        inset
        label={'Tipo:'}
        options={mediaTypeOptions}
        value={[{ id: mediaType }]}
        onChange={(params) => {
          setMediaType(params.option?.id as string);
        }}
      />
      <EnhancedLabeledSelect
        inline
        inset
        label={'Origen:'}
        options={originOptions}
        value={[{ id: origin }]}
        onChange={(params) => {
          setOrigin(params.option?.id as string);
        }}
      />
      <AlarmTypeSelect
        alarmTypeId={alarm === undefined ? undefined : `${alarm}`}
        onChange={(alarmId) => setAlarm(alarmId ? +alarmId : undefined)}
      />
    </FlexRow>
  );
}

export default EvidencesReportFilters;
